import script from "./CancelConferenceDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CancelConferenceDialog.vue?vue&type=script&setup=true&lang=ts"

import "./CancelConferenceDialog.vue?vue&type=style&index=0&id=ae8a1da8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae8a1da8"]])

export default __exports__